import { useQuery } from '@tanstack/react-query';
import type { BrandReportDto, SponsorshipDto } from '@rw/shared';
import { api } from '../../lib/api';

export const ledgerKeys = { all: ['admin', 'sponsorships'] as const };

/** Game owner: the sponsorship ledger, newest pledge first. */
export const useLedger = () => useQuery({ queryKey: ledgerKeys.all, queryFn: () => api<SponsorshipDto[]>('/admin/sponsorships') });

export const useBrandReport = (brandId: string, from: string, to: string) =>
  useQuery({
    queryKey: ['admin', 'report', brandId, from, to],
    queryFn: () => api<BrandReportDto>(`/admin/reports/brands/${brandId}`, { query: { from: from || undefined, to: to || undefined } }),
  });

export const formatVnd = (n: number) => `${new Intl.NumberFormat('vi-VN').format(n)} ₫`;
